import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { BiMessageAltError } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const TerrorismInformationComponent = ({ data }) => {
  const [user, setUser] = useState(data);
  const [isEditing] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  const handleTerrorist = (e, user) => {
    const data = user;
    e.preventDefault();
    navigate("/informe/terrorismo-pdf", { state: data });
  };

  return (
    <div className={styles.informacionPolitica} id="terrorismo">
      <div className={styles.sectionTitle2}>
      <div className={styles.sectionTitle3}>
        <h2 className={styles.sectionTitleH2}>Información Terrorismo</h2>
        <IconAnimation />
      </div>
        {!user ? (
          <></>
        ) : (
          <div className="abmlistviewbutton">
            <button
              type="button"
              id="idbuttonabmviewlist"
              className="buttonviewñostabm"
              onClick={(e) => handleTerrorist(e, user)}
            >
              <i className="fa fa-refresh"></i> Terrorismo
              <FaArrowRight className={styles.icon} />
            </button>
          </div>
        )}
      </div>
      {!user || !user.PoliticalInformation ? (
        <NotReportViewData
          title="Información Terrorismo"
          Icon={BiMessageAltError}
        />
      ) : (
        <div className={styles.terroristbox}>
          <label className={styles.inputfieldterrorism}>
            Verificación de terrorismo (DNI):
            <input
              className={styles.inputField}
              type="text"
              name="terrorismVerification"
              value={user.PoliticalInformation.terrorismVerification || ""}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.inputfieldterrorism}>
            Resultado: <br />
            <span className={styles.inputField}>
              {user.PoliticalInformation.verification}
            </span>
          </label>
        </div>
      )}
    </div>
  );
};

export default TerrorismInformationComponent;
